<template>
    <!-- 对话框 -->
    <el-drawer :visible.sync="show" :with-header="false" :before-close="closeDialog" size="80%">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto">
                    <el-form-item label="活动名称:" label-width="120px">
                        <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 80%"> </el-input>
                    </el-form-item>
                    <el-form-item label="生效日期:" label-width="120px">
                        <el-date-picker
                            v-model="timeValue"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item label="活动图片:" label-width="120px">
                        <el-image
                            :preview-src-list="srcList"
                            v-if="img_url.cover_img_imageUrl"
                            :src="img_url.cover_img_imageUrl"
                            class="avatar"
                        ></el-image>
                        <el-upload
                            :class="img_url.cover_img_imageUrl ? 'border-none' : ''"
                            class="avatar-uploader"
                            :action="img_upload_url"
                            :show-file-list="false"
                            :before-upload="beforeAvatarUpload"
                            :headers="img_headers"
                        >
                            <el-button
                                slot="trigger"
                                v-if="img_url.cover_img_imageUrl"
                                @click="img_url.cover_img_imageUrl = ''"
                                style="width: 100px; margin-top: 10px"
                                >更换图片</el-button
                            >
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>

                    <el-form-item label-width="100px">
                        <p class="text-red">*注：活动图片尺寸应为650*712</p>
                    </el-form-item>

                    <el-form-item label="链接跳转模式:" label-width="120px">
                        <el-select v-model="submit_data.type" placeholder="请选择" @change="typeChange">
                            <el-option label="跳转网页" value="0"> </el-option>
                            <el-option label="小程序" value="1"> </el-option>
                            <el-option label="内部链接" value="3"> </el-option>
                            <el-option label="不跳转" value="4"> </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="内部链接地址:" v-if="submit_data.type == '3'" label-width="120px">
                        <el-select v-model="submit_data.inside_link" placeholder="请选择">
                            <el-option v-for="item in insideLinkList" :label="item.name" :value="item.key"> </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="小程序原始id:" label-width="120px" v-if="submit_data.type == '1'">
                        <el-input v-model="submit_data.origin_appid" style="width: 80%"> </el-input>
                    </el-form-item>

                    <el-form-item label="小程序appid:" label-width="120px" v-if="submit_data.type == '1'">
                        <el-input v-model="submit_data.appid" style="width: 80%"> </el-input>
                    </el-form-item>

                    <el-form-item label="链接地址:" label-width="120px" v-if="submit_data.type != '4'">
                        <el-input v-model="submit_data.link" style="width: 80%"> </el-input>
                    </el-form-item>

                    <el-form-item label="备注:" label-width="120px">
                        <el-input v-model="submit_data.remarks" style="width: 80%"> </el-input>
                    </el-form-item>
                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center; margin-top: 20px">
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-drawer>
</template>

<script>
var _this;
import { config } from '@/utils/config'; // 配置
import axios from 'axios'; // AJAX封装类

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
export default {
    components: {
        quillEditor
    },
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            // 获取上传图片的地址
            this.img_upload_url = config.axios_imgURL;

            // 清空图片的路径
            this.img_url = {
                cover_img_imageUrl: ''
            };

            // axios.defaults.baseURL = config.axios_normalURL; //请求base url
            _this
                .$post('/system/getInsideLink',{},{},'normal')
                .then((res) => {
                    _this.insideLinkList = res.data;

                    // axios.defaults.baseURL = config.axios_baseURL; //请求base url
                })
                .catch((err) => {});
            // axios.defaults.baseURL = config.axios_baseURL; //请求base url

            // 获取广告详情
            _this
                .$post('/advert/getActiveDetails', {
                    active_code: _this.data
                })
                .then((res) => {
                    _this.submit_data.active_code = res.data.active_code;
                    _this.submit_data.origin_appid = res.data.origin_appid;
                    _this.submit_data.name = res.data.name;
                    _this.submit_data.appid = res.data.appid;
                    _this.submit_data.remarks = res.data.remarks;
                    _this.submit_data.type = res.data.type;
                    _this.submit_data.link = res.data.link;

                    if (res.data.start_time.Ymd != '未设置') {
                        _this.submit_data.start_time = res.data.start_time.Ymd;
                        //  console.log(_this.timeValue,'=========');
                        _this.timeValue.push(res.data.start_time.Ymd);
                    } else {
                        _this.submit_data.start_time = '';
                    }

                    if (res.data.end_time.Ymd != '未设置') {
                        _this.submit_data.end_time = res.data.end_time.Ymd;
                        _this.timeValue.push(res.data.end_time.Ymd);
                    } else {
                        _this.submit_data.end_time = '';
                    }

                    // _this.submit_data.end_time = res.data.end_time.Ymd == '未设置'?'':'';
                    _this.submit_data.inside_link = res.data.inside_link;

                    _this.submit_data.cover_img_hash = res.data.cover_img.hash;

                    _this.img_url.cover_img_imageUrl = res.data.cover_img.url;
                    console.log(_this.img_url.cover_img_imageUrl);

                    this.srcList[0] = this.img_url.cover_img_imageUrl;
                })
                .catch((res) => {});
        }
    },
    data() {
        return {
            show: false,
            timeValue: [],

            // 图片上传地址
            img_upload_url: '',

            insideLinkList: [],

            srcList: [],

            //上传图片
            img_url: {
                cover_img_imageUrl: '',
                logo_img_imageUrl: '',
                list_img_imageUrl: ''
            },

            //压缩质量
            imgQuality: 1,

            // 上传图片的请求头
            img_headers: {
                token: '',
                'hash-key': '',
                platform: 'pc',
                'app-version': 'admin',
                port: 'admin',
                'city-tag': localStorage.getItem('city_tag'),
                'service-tag':localStorage.getItem('service_tag')
            },

            // 表单数据
            submit_data: {
                origin_appid: '',
                appid: '',
                cover_img_hash: '',
                type: '',
                link: '',
                name: '',
                remarks: '',
                inside_link: '',
                start_time: '',
                end_time: ''
            },

            submit_rules: {
                name: {
                    placeholder: '请输入广告名称',
                    rules: {
                        required: true,
                        message: '广告名称需在5-50字之内',
                        regulation: 'between',
                        rulesData: [5, 51]
                    }
                },
                start_time: {
                    placeholder: '请输入开始日期',
                    rules: {
                        required: false,
                        message: '请输入开始时间',
                        regulation: 'lt_str',
                        rulesData: 30
                    }
                },
                end_time: {
                    placeholder: '请输入结束日期',
                    rules: {
                        required: false,
                        message: '请输入结束时间',
                        regulation: 'lt_str',
                        rulesData: 30
                    }
                },
                cover_img_hash: {
                    placeholder: '',
                    rules: {
                        required: true,
                        message: '封面图片哈希值错误',
                        regulation: 'lt_str',
                        rulesData: 'json_array'
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        typeChange() {
            if (_this.submit_data.type == '0') {
                _this.submit_data.origin_appid = '';
                _this.submit_data.appid = '';
            }
        },
        // 判断图片的img_url是否存在
        imgUrlDeg() {
            if (_this.img_url.cover_img_imageUrl !== '') {
                return true;
            } else {
                _this.$message.error('未上传图片信息');
                return false;
            }
        },

        // 图片上传之前执行的函数
        beforeAvatarUpload(file) {
            //file代表上传的文件，isSave代表上传的policyName参数是临时文件还是永久文件。permanent（永久文件）temporary（临时文件）
            _this.$uploadImage({ file: file, isSave: 'permanent' }).then((res) => {
                // console.log(file, '1============');
                console.log(res, 'res');

                // 将返回的哈希值存到submit_data对象
                _this.submit_data.cover_img_hash = res.hash;

                // 设置img标签显示的图片路径
                _this.img_url.cover_img_imageUrl = URL.createObjectURL(file);

                //上传图片后点击预览
                _this.srcList.push(String(_this.img_url.cover_img_imageUrl));
            });

            return false;
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.timeValue = [];

            _this.submit_data = {
                origin_appid: '',
                appid: '',
                cover_img_hash: '',
                type: '',
                link: '',
                name: '',
                remarks: '',
                inside_link: '',
                start_time: '',
                end_time: ''
            };
        },

        // 提交
        onSubmit() {
            if (_this.timeValue == null) {
                _this.submit_data.start_time = '';
                _this.submit_data.end_time = '';
            } else {
                _this.submit_data.start_time = _this.timeValue[0];
                _this.submit_data.end_time = _this.timeValue[1];
            }
            _this
                .$post('/advert/editActiveSubmit', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    // 触发父组件自定义事件刷新表格
                    _this.$emit('onSubmit');
                    _this.closeDialog();
                    this.$message.success(res.msg);
                })
                .catch((res) => {});
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
}

.verify_remarks {
    font-size: 14px;
    color: #606266;
}

.quill-editor {
    width: 80%;
}
.text-red {
    color: red;
    font-size: 14px;
}
</style>
